import { Project } from '@bulthaup/api/db';
import { Button, Group, Stack, Text } from '@mantine/core';

import { useBooleanButtonState } from './-hooks/-use-boolean-button-state';

type BooleanField = 'isBulthaupOrderSent' | 'isApplianceOrderSent';

export function OrderSentSection({ project }: { project: Project }) {
  const { isFieldPending, toggleBooleanState } =
    useBooleanButtonState<BooleanField>({
      project,
      fieldConfigs: {
        isBulthaupOrderSent: {
          successMessage: 'État commande bulthaup mis à jour',
        },
        isApplianceOrderSent: {
          successMessage: 'État commande électro mis à jour',
        },
      },
    });

  const isBulthaupOrderSent = project.isBulthaupOrderSent ?? false;
  const isApplianceOrderSent = project.isApplianceOrderSent ?? false;

  return (
    <Stack>
      <Group justify="space-between" wrap="nowrap" align="flex-start">
        <Text style={{ flex: 1, minWidth: 0 }}>Commande bulthaup envoyée</Text>
        <Button
          color={isBulthaupOrderSent ? 'green' : 'red'}
          variant="filled"
          onClick={() =>
            void toggleBooleanState('isBulthaupOrderSent', isBulthaupOrderSent)
          }
          disabled={isFieldPending('isBulthaupOrderSent')}
          loading={isFieldPending('isBulthaupOrderSent')}
          style={{ flexShrink: 0 }}
        >
          {isBulthaupOrderSent ? 'OUI' : 'NON'}
        </Button>
      </Group>

      <Group justify="space-between" wrap="nowrap" align="flex-start">
        <Text style={{ flex: 1, minWidth: 0 }}>Commande électro envoyée</Text>
        <Button
          color={isApplianceOrderSent ? 'green' : 'red'}
          variant="filled"
          onClick={() =>
            void toggleBooleanState('isApplianceOrderSent', isApplianceOrderSent)
          }
          disabled={isFieldPending('isApplianceOrderSent')}
          loading={isFieldPending('isApplianceOrderSent')}
          style={{ flexShrink: 0 }}
        >
          {isApplianceOrderSent ? 'OUI' : 'NON'}
        </Button>
      </Group>
    </Stack>
  );
}
